import { useFxRates } from './use-fx-rates';
import { setLiveRates } from '@/services/currency/currency-service';
import { useRatesInjector } from './use-rates-injector';

export const useFxRatesSync = () => {
  // Inject the live feed into currency-service on arrival + bump the shared FX version so memoised
  // on-page currency roll-ups (the Trades/MTM footer ≈-totals, the pill's Σ≈) recompute against the
  // freshly-landed rates instead of staying frozen on the cold-load fallback (LR-469 hooks-1). The
  // injection body is shared with useCobFxRatesSync via useRatesInjector (review CU6); the two differ
  // only in the query, the target store, and the returned flag. isUsingFallback = loaded but no rates.
  const { isLoading, isError, hasRates } = useRatesInjector(useFxRates(), setLiveRates);
  return { isLoading, isError, isUsingFallback: !isLoading && !hasRates };
};
